import LinkSet from './LinkSet';
import { withUser } from '../../../data-providers/user';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import get from 'lodash/get';

const enhance = compose(
  withUser,
  withProps(props => ({
    linkItems: props.linkSet.items
      .filter(
        item => (get(props, 'user.response.ok') ? true : !item.url.includes('/logout')),
      )
      .map(
        item =>
          item.url.includes('/logout')
            ? item
            : { ...item, url: localiseUrl(props.country, item.url) },
      ),
  })),
);

export default enhance(LinkSet);
